namespace SPA {
	export namespace Realtor {

		export interface IRealtorObject {
			Address?: Wollmilch.PostalAddressObject;
			AdvData: any;
			Attachments?: Wollmilch.Realtor.Attachment[];
			Contractor?: any;
			Customer?: any;
			CreatedAt: ICreatedAt;
			Creator?: any;
			Data: SPA.Realtor2.INewDisposalObject;
			ImmoWertV: number | null;
			MainImage: string;
			Object:
				{
					Address?: Wollmilch.PostalAddressObject,
					CreatedAt: ICreatedAt,
					ID: number,
					Type: string,
				};
			ObjectNumber: string;
			Owner?: Wollmilch.Realtor.ObjectOwner | null;
			Type: "DisposalRealtorObject" | "LetRealtorObject";
		}

		export interface ICreatedAt {
			date: string;
			timezone: string;
			timezone_type: number;
		}

		export class RealtorObjectModel extends Backbone.Model implements IRealtorObject {
			public constructor(data: IRealtorObject) {
				const defaults = RealtorObjectModel.getDefaults();
				_.extend(defaults, data);

				super(defaults);
			}

			get Address(): Wollmilch.PostalAddressObject {
				return this.get('Address');
			}

			set Address(address: Wollmilch.PostalAddressObject) {
				this.set('Address', address);
			}

			get AdvData() {
				return this.get('AdvData');
			}

			set AdvData(data: any) {
				this.set('AdvData', data);
			}

			get Attachments(): Wollmilch.Realtor.Attachment[] {
				return this.get('Attachments');
			}

			set Attachments(attachments: Wollmilch.Realtor.Attachment[]) {
				this.set('Attachments', attachments);
			}

			get Contractor() {
				return this.get('Contractor');
			}

			set Contractor(contractor: any) {
				this.set('Contractor', contractor);
			}

			get Customer() {
				return this.get('Customer');
			}

			set Customer(customer: any) {
				this.set('Customer', customer);
			}

			get CreatedAt(): ICreatedAt {
				return this.get('CreatedAt');
			}

			set CreatedAt(CreatedAt: ICreatedAt)
			{
				this.set('CreatedAt', CreatedAt);
			}

			get Creator() {
				return this.get('Creator');
			}

			set Creator(creator: any) {
				this.set('Creator', creator);
			}

			get Data(): SPA.Realtor2.INewDisposalObject {
				return this.get('Data');
			}

			set Data(data: SPA.Realtor2.INewDisposalObject) {
				this.set('Data', data);
			}

			get ImmoWertV(): number | null {
				return this.get('ImmoWertV');
			}

			set ImmoWertV(value: number | null) {
				this.set('ImmoWertV', value);
			}

			get MainImage(): string {
				return this.get('MainImage');
			}

			set MainImage(image: string) {
				this.set('MainImage', image);
			}

			get Object(): Wollmilch.PostalAddressObject {
				return this.get('Object');
			}

			set Object(object: Wollmilch.PostalAddressObject) {
				this.set('Object', object);
			}

			get ObjectNumber(): string {
				return this.get('ObjectNumber');
			}

			set ObjectNumber(object_number: string) {
				this.set('ObjectNumber', object_number);
			}

			get Owner(): Wollmilch.Realtor.ObjectOwner | null {
				return this.get('Owner');
			}

			set Owner(owner: Wollmilch.Realtor.ObjectOwner | null) {
				this.set('Owner', owner);
			}

			get Type(): "DisposalRealtorObject" | "LetRealtorObject" {
				return this.get('Type');
			}

			set Type(type: "DisposalRealtorObject" | "LetRealtorObject") {
				this.set('Type', type);
			}

			public static getDefaults(): Backbone.ObjectHash {
				return {
					AdvData: [],
					Data: SPA.Realtor2.NewDisposalObject.getDefaults(),
					ImmoWertV: null,
					MainImage: '',
					ObjectNumber: '',
					Owner: null,
					Type: "DisposalRealtorObject"
				};
			}
		}
	}
}
